import React from "react";
import Building from "./Building";


const Buildings = (props) => {

	return (
		<div className='buildings'>
			{props.data.map((building, index) => <Building key={index} data={building} status={props.status} statusChange={props.statusChange} appName={props.appName}/>)}
		</div>
	);
};

export default Buildings;